import React from 'react';
import NeonDivider from './NeonDivider';

const OrderSection = () => {
  return (
    <section id="order" className="py-20 px-4 bg-gradient-to-b from-black via-black/95 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-logoSans text-ivory mb-4">
            ORDER ONLINE
          </h2>
          <p className="text-gray text-lg max-w-2xl mx-auto">
            Get your Billy's WingCo favorites delivered or ready for pickup. 
            Same legendary flavors, now at your fingertips.
          </p>
        </div>

        <NeonDivider color="neonRed" />

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Delivery & Pickup Options */}
          <div className="space-y-8">
            <div className="text-center lg:text-left">
              <h3 className="text-2xl md:text-3xl font-logoSans text-ivory mb-6">
                ORDER OPTIONS
              </h3>
            </div>

            {/* Delivery */}
            <div className="p-6 border border-neonBlue/20 rounded-xl bg-black/30 backdrop-blur-sm hover:border-neonBlue/40 transition-all duration-200">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-neonBlue/10 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-neonBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h4 className="text-xl font-logoSans text-ivory">Delivery</h4>
              </div>
              <h3 className="text-lg font-logoSans text-ivory mb-4 text-center">
                Delivery via Uber Eats • DoorDash • Skip The Dishes
              </h3>
              <p className="text-gray mb-4">
                Hot, fresh wings delivered to your door. Available within 5km of our location.
              </p>
              <ul className="text-gray text-sm space-y-2 mb-6">
                <li>• Delivery time: 30-45 minutes</li>
                <li>• Minimum order: $25</li>
                <li>• Delivery fee: $3.99</li>
                <li>• Free delivery over $50</li>
              </ul>
              
              {/* Delivery Buttons */}
              <div className="space-y-3">
                {/* Uber Eats - Currently Unavailable */}
                <div className="relative">
                  <button
                    disabled
                    className="inline-flex items-center bg-gray-600 text-gray-400 px-6 py-3 rounded-lg font-semibold
                               w-full justify-center cursor-not-allowed opacity-50 touch-target"
                  >
                    Order Uber Eats
                  </button>
                  <div className="absolute inset-0 bg-black/70 rounded-lg flex items-center justify-center">
                    <span className="text-neonRed text-sm font-semibold">Currently Unavailable</span>
                  </div>
                </div>
                
                {/* Skip The Dishes - Live */}
                <a
                  href="https://www.skipthedishes.com/wingporium-scarborough-village"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-neonBlue text-black px-6 py-3 rounded-lg font-semibold
                             shadow-neonBlue hover:animate-flicker hover:-translate-y-0.5 
                             transition-all duration-200 w-full justify-center touch-target"
                >
                  Order Skip The Dishes
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
                
                {/* DoorDash - Live */}
                <a
                  href="https://www.doordash.com/en-CA/store/wingporium-scarborough-village-toronto-965283/1412090/?srsltid=AfmBOoqxytkQLuh3_9rKeZHFTGf0lmFrtuvLUQt1hKhc2ute9YZxhdGK"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-neonBlue text-black px-6 py-3 rounded-lg font-semibold
                             shadow-neonBlue hover:animate-flicker hover:-translate-y-0.5 
                             transition-all duration-200 w-full justify-center touch-target"
                >
                  Order DoorDash
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Pickup */}
            <div className="p-6 border border-neonRed/20 rounded-xl bg-black/30 backdrop-blur-sm hover:border-neonRed/40 transition-all duration-200">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-neonRed/10 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-neonRed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h4 className="text-xl font-logoSans text-ivory">Pickup</h4>
              </div>
              <p className="text-gray mb-4">
                Order ahead and skip the wait. Perfect for those legendary wings on the go.
              </p>
                              <div className="mb-4 p-3 bg-neonRed/10 rounded-lg">
                  <h5 className="text-sm font-semibold text-ivory mb-2">Pickup Hours</h5>
                  <div className="text-xs sm:text-sm text-gray space-y-1">
                    <div className="flex justify-between">
                      <span>Sun–Tue:</span>
                      <span className="font-medium">12 PM – 12 AM</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Wed–Sat:</span>
                      <span className="font-medium">12 PM – 1 AM</span>
                    </div>
                  </div>
                  <p className="text-xs text-gray mt-2 italic" style={{fontVariant: 'small-caps'}}>
                    Pickup closes 1 hour before dining-room close
                  </p>
                </div>
              <ul className="text-gray text-sm space-y-2 mb-4">
                <li>• Ready in: 15-20 minutes</li>
                <li>• No minimum order</li>
                <li>• No fees</li>
                <li>• Call ahead: (416) 265-9223</li>
              </ul>
              <div className="mb-6">
                <a
                  href="https://maps.app.goo.gl/X8SdCHyZtU65jmyF8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-neonBlue hover:text-ivory transition-colors duration-200 text-sm font-medium"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                  </svg>
                  Get Directions for Pickup
                  <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              <a
                href="tel:+14162659223"
                className="inline-flex items-center bg-neonRed text-white px-6 py-3 rounded-lg font-semibold
                           shadow-neonRed hover:animate-flicker hover:-translate-y-0.5 
                           transition-all duration-200 w-full sm:w-auto justify-center"
              >
                Call to Order
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Order */}
          <div className="space-y-8">
            <div className="text-center lg:text-left">
              <h3 className="text-2xl md:text-3xl font-logoSans text-ivory mb-6">
                POPULAR ORDERS
              </h3>
            </div>

            <div className="space-y-4">
              {[
                { name: "1 Lb Original Wings", desc: "Choice of one flavour, dusted or non", price: "$18.00", popular: true },
                { name: "Poutine", desc: "Our fries smothered in mozzarella and gravy", price: "$14.00" },
                { name: "Billy's Burger", desc: "Beef, lettuce, tomato, and onion rings with secret sauce", price: "$18.00", popular: true },
                { name: "Billy's Marg", desc: "Tequila, triple sec, lime juice - Simple, classic, and always a crowd-pleaser", price: "Market Price" }
              ].map((item, index) => (
                <div key={index} className="p-4 border border-gray/10 rounded-lg bg-black/20 backdrop-blur-sm hover:border-neonBlue/30 transition-all duration-200">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="font-logoSans text-ivory">{item.name}</h4>
                        {item.popular && (
                          <span className="text-xs bg-neonRed text-white px-2 py-1 rounded-full">POPULAR</span>
                        )}
                      </div>
                      <p className="text-gray text-sm">{item.desc}</p>
                    </div>
                    <div className="text-neonRed font-bold text-lg ml-4">
                      {item.price}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center pt-6">
              <a
                href="#menu"
                className="inline-flex items-center border-2 border-neonBlue text-neonBlue px-8 py-3 rounded-lg 
                           font-semibold hover:bg-neonBlue hover:text-black hover:shadow-neonBlue 
                           hover:-translate-y-0.5 transition-all duration-200"
              >
                View Full Menu
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderSection; 